<div class="pending-container">
  <div *ngIf="isLoading" class="spinner-grow text-primary" role="status" class=".loader">
    <span class="sr-only">Loading...</span>
  </div>
  <div *ngIf="!isLoading" class="pending-content">
    <div class="pending-icon">
      <i class="material-icons">schedule</i>
    </div>
    <h1>Pago en Proceso</h1>
    <p>Tu pago está siendo procesado. Esto puede tomar unos minutos.</p>

    <div class="payment-details">
      <p><strong>ID de Pago:</strong> {{ paymentId }}</p>
      <p><strong>Estado:</strong> {{ status }}</p>
      <p><strong>ID de Orden:</strong> {{ merchantOrderId }}</p>
    </div>

    <div class="loading-spinner">
      <div class="spinner"></div>
    </div>

    <button class="btn-home" (click)="goToHome()" aria-label="Volver a la página de inicio">
      Volver al inicio
    </button>
  </div>
</div>